<div class="loader-overlay" [hidden]="!show"><div class="progress">
    <div class="indeterminate"></div></div></div>